export default "__VITE_ASSET__a6e00bd1__"